import React from 'react';
import {useMenu} from '../../../hooks/useMenu';
import ProgressBarView from '../../views/progressbarView';
import SaveConfigTN from './save-configTN';

function SaveConfigPB() {
  const {onComponent} = useMenu();
  return (
    <ProgressBarView
      title="Saving Configuration"
      content="Saving backup configuration file..."
      onExit={() => onComponent(<SaveConfigTN />)}
    />
  );
}

export default SaveConfigPB;
